(function() {
	'use strict';

	angular.module('quantixApp').controller('industryProfileDetailsController',
			industryProfileDetailsController);

	industryProfileDetailsController.$inject = [ '$scope', '$state',
			'$timeout', 'ErrorHandlerService', 'industryService',
			'InsightsService', '$uibModal', '$stateParams', '$http',
			'$rootScope', 'GenericServiceNew', '$anchorScroll',
			'CompanyProfileService', 'GenericService', 'INDUSTRY_PROFILE',
			'$window', '$location', ];

	function industryProfileDetailsController($scope, $state, $timeout,
			ErrorHandlerService, industryService, InsightsService, $uibModal,
			$stateParams, $http, $rootScope, GenericServiceNew, $anchorScroll,
			CompanyProfileService, GenericService, INDUSTRY_PROFILE, $window,
			$location) {

				// added to test plotly options
				
			$scope.modebarOptions = {
				showLink : false,
				displaylogo : false,
				modeBarButtonsToRemove : ['sendDataToCloud','zoom2d','pan2d','select2d','lasso2d','zoomIn2d','zoomOut2d','autoScale2d','toggleSpikelines','hoverClosestCartesian','hoverCompareCartesian']
			};

			if ($window.localStorage.IndustryIDToRedirect) {
				$stateParams = JSON
						.parse($window.localStorage.IndustryIDToRedirect);
				$window.localStorage.removeItem('IndustryIDToRedirect');
				$state.params = $stateParams;
			}
		// added for Menu icon active by venketeswar
		$scope.$parent.activeMenu = "industry";

		$scope.loadratinglongshort = false;
		$scope.loadparams = false;
		$scope.loadmymaindirective = false;
		$scope.showClusterCharerr = false;
		$scope.clusterinfohide = false;
		$scope.loadingRatingTrend = true;
		$scope.loadingFinancialIndicators = true;
		
		$scope.industryId=$state.params.industryId || $window.localStorage.industryId;// Nikhil Umale

		$scope.goTo = false; // nikhil umale
		GenericService.getUserModuleAccessData().then(function(result){
			$scope.userModuleAccessData =result;
			if (!$scope.userModuleAccessData[INDUSTRY_PROFILE]) {
				ErrorHandlerService.forbiddenError(INDUSTRY_PROFILE);
				return;
			}
		});
		$scope.errorNews=false;
		var sectionaccess = {}
		GenericService.getUserSectionAccessData().then(function(result){
			sectionaccess =result;
			if (sectionaccess["Industry Profile.News"] != 'Y') {
				$scope.errorNews = true;
				$scope.errorMessageNews = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
	
			}
		});
		
		$scope.gotolandingpage = function() {
			$state.go("industryProfileMain");
			return;
		}

		$scope.setAlert = function() {
			$uibModal
					.open({
						templateUrl : 'app/industry/industryProfile/IndustryProfileSetAlert.html',
						controller : 'industryProfielSetAlert',
						controllerAs : 'vm',
						size : 'lg',
						resolve : {
							industryId : function() {
								return $scope.industryId;
							}
						}
					}).closed.then(function() {
			});
		}
		// Modified for bug id 52027
		$scope.loaddir =  false;
		
		if($state.params.industryId==null && !$window.localStorage.industryId){
			$scope.gotolandingpage();
			return;
		}
	// Method Changed By Nikhil Umale for Search Company bug id 52027

		$scope.getIndustryData=function(Type){
			$scope.type=Type;
			

			if($scope.type=="Annual")
				{
				
				industryService.getAggFinancials($stateParams.industryId || $window.localStorage.industryId)
				.then(
						function(response){		
							industryService.getRecentlyViewed($stateParams.compObj || $window.localStorage.compObj)
							.then( function(response){

 							},function(reject){
 							}
									)
						promiseForIndustryDataParams(response).then(function (isDataDoneExecuting) {
							$scope.getAllIndustryData();
							});
						 
														
						}, function(error){
 						})	
				}
			
			
			
		}
		
		
		$scope.getIndustryData("Annual");
		
		function promiseForIndustryDataParams(response){
			return new Promise(function(resolve, reject) {
				$scope.listformovements = {};
				$scope.listformovements.upwards = response[0][0];
				$scope.listformovements.downwards = response[0][1];
				$scope.listformovements.mixed = response[0][2];
				$state.params.movements=$scope.listformovements;
				for (var i = 0; i < response[1].length; i++) {
					for(var j = 0; j < response[1][i].length; j++){
						if( response[1][i][j] == "∞" || response[1][i][j] == "Infinity"){
							response[1][i][j] = "n.m.";
						}
					}
				}
			 	$scope.outputParameters = response[1];
			 	$state.params.objtodisplay=$scope.outputParameters;
				$scope.dataForIndustryIndicator = response[2];
				if($scope.dataForIndustryIndicator[4]['Revenue Growth']) {
					var revenueKeys = Object.keys($scope.dataForIndustryIndicator[4]['Revenue Growth']);
					revenueKeys.forEach( function( prop ) {
						if(!$scope.dataForIndustryIndicator[2]['ROE'].hasOwnProperty( prop )) {
							delete $scope.dataForIndustryIndicator[4]['Revenue Growth'][prop];
						}
					});
				}
				$state.params.indicator=$scope.dataForIndustryIndicator;
				
				$scope.dataForDrillDown = response[3];
				$state.params.drill=$scope.dataForDrillDown;
				
			
				$scope.newsdata = response[6];
				
				$state.params.news=$scope.newsdata;
				// Yash
				$scope.industryType = response[5] ;
				$state.params.industryType=$scope.industryType;
				
				$scope.companyYear = response[4] ;
				$state.params.companyYear=$scope.companyYear;
				
				$scope.loaddir =  true;
				
				$scope.objectToDisplay();

				resolve("Success");

				});
		}

		$scope.clusterhide = false;

		$scope.showpie = true;

		
		
		
		$scope.getIndustryType = function(){

			if ($scope.industryType == 18 || $scope.industryType == 19) {
					$scope.mfg = true;
					$scope.bnk = false;
					$scope.profitability = true;
					$scope.debt = false;
					// Yash
					$scope.bank_profitability = false;
					$scope.bank_assest = false;
					// Yash
					$scope.drillhide = false;
				} else {
					$scope.bnk = true;
					$scope.mfg = false;
					$scope.profitability = false;
					$scope.debt = false;
					$scope.bank_profitability = true;
					$scope.bank_assest = false;
					$scope.drillhide = false;
				}

		}

		$scope.objectToDisplay = function(){

		if ($state.params.objtodisplay != null
						&& $state.params.objtodisplay != "") {

					$scope.loadingFinancialIndicators = false;

					$scope.outputParameters = $state.params.objtodisplay;

					// nikhil umale
					for (var i = 0; i < $scope.outputParameters.length; i++) {
						if ($scope.outputParameters[i][1] == "Rs. Crore") {
							$scope.outputParameters[i][1] = "Rs. Crore";
						}
					}

					$scope.listformovements = $state.params.movements;
					$scope.industryId = $state.params.industryId || $window.localStorage.industryId;
					$scope.ratios = $state.params.indicator;
					$scope.industryType = $state.params.industryType;
					$scope.drilldown = $state.params.drill;
					$scope.news = $state.params.news;
					$scope.label = $state.params.label;

					$scope.year = $state.params.year;

					$scope.yrobj = {};

					$scope.yrobj.year = $state.params.year;

					$scope.newsreport = JSON.parse($state.params.news);

					$scope.newsreport.sort(function(a, b) {
						return new Date(b.date).getTime() - new Date(a.date).getTime();
					})

					$scope.newstorender = $scope.newsreport.splice(0, 6);

					$scope.companyYear = $state.params.companyYear;
					$scope.getIndustryType();
					$scope.getRatios();

				} else {

					$scope.gotolandingpage();

				}
		}


		$scope.getRatios = function(){
			
			$scope.datafordebt=[];
			$scope.dataforindustryindicators=[];
			$scope.profitableIndiacator=[];
			$scope.assetQuality=[];

			for ( var s in $scope.ratios) {
				for ( var k in $scope.ratios[s]) {

					if (k == 'Revenue Growth' || k == 'ROE' || k == 'ROCE') {

						var mapobj = getObjForLineAndBarChart();
						if (mapobj.name == '') {
							mapobj.name = k;
						}

						mapobj.x = Object.keys($scope.ratios[s][k]);


						mapobj.y = Object.keys($scope.ratios[s][k]).map(
								function(key) {
									return $scope.ratios[s][k][key];
								});

						if (k == 'Revenue Growth') {
							mapobj.type = 'scatter';
							mapobj.yaxis = 'y2';
							mapobj.marker = {
								color : 'rgb(238,207,186)'
							};

						} else {
							mapobj.type = 'bar';

							if (k == 'ROE') {

								mapobj.marker = {
									color : 'rgb(131,184,170)'
								};

							}
							if (k == 'ROCE') {

								mapobj.marker = {
									color : 'rgb(100,118,133)'
								};

							}

						}

						$scope.dataforindustryindicators.push(mapobj);

					} else if (k == 'interest coverage ratio'
							|| k == 'Debt/Equity Ratio') {

						var mapobj = getObjForLineAndBarChart();
						if (mapobj.name == '') {
							mapobj.name = k;
						}

						mapobj.x = Object.keys($scope.ratios[s][k]);
						mapobj.y = Object.keys($scope.ratios[s][k]).map(
								function(key) {
									return $scope.ratios[s][k][key];
								});


						if (k == 'interest coverage ratio') {

							mapobj.type = 'scatter';
							mapobj.marker = {
								color : 'rgb(131,184,170)'
							}

						} else if (k == 'Debt/Equity Ratio') {
							mapobj.type = 'scatter';
							mapobj.yaxis = 'y2';
							mapobj.marker = {
								color : 'rgb(100,118,133)'
							}

						}
						;

						$scope.datafordebt.push(mapobj);

					}
					// Yash
					else if (k == 'NII/TA' || k == 'RPAT/TA' || k == 'Non-II/TA'
							|| k == 'Total Operating expenditure'
							|| k == 'Provision') {

						var mapobj = getObjForLineAndBarChart();
						if (mapobj.name == '') {
							mapobj.name = k;
						}

						mapobj.x = Object.keys($scope.ratios[s][k]);
						mapobj.y = Object.keys($scope.ratios[s][k]).map(
								function(key) {
									return $scope.ratios[s][k][key];
								});


						if (k == 'NII/TA' || k == 'RPAT/TA' || k == 'Non-II/TA') {

							mapobj.type = 'scatter';
							mapobj.yaxis = 'y2';

							if (k == 'NII/TA') {

								mapobj.marker = {
									color : 'rgb(100,118,133)'
								};

							}
							if (k == 'RPAT/TA') {

								mapobj.marker = {
									color : 'rgb(67,174,168)'
								};
							}
							if (k == 'Non-II/TA') {

								mapobj.marker = {
									color : 'rgb(104,129,186)'
								};
							}

						} else if (k == 'Total Operating expenditure'
								|| k == 'Provision') {

							mapobj.type = 'bar';
							if (k == 'Total Operating expenditure') {

								mapobj.marker = {
									color : 'rgb(131,184,170)'
								};

							}
							if (k == 'Provision') {

								mapobj.marker = {
									color : 'rgb(100,118,133)'
								};

							}

						}
						// ;

						$scope.profitableIndiacator.push(mapobj);

					} else if (k == 'Capital Adequacy Ratio'
							|| k == 'Gross NPA / Loans & Advances'
							|| k == 'Net NPA / Loans & Advances'
							|| k == 'Tier 1 Capital Adequacy') {

						var mapobj = getObjForLineAndBarChart();
						if (mapobj.name == '') {
							mapobj.name = k;
						}

						mapobj.x = Object.keys($scope.ratios[s][k]);
						mapobj.y = Object.keys($scope.ratios[s][k]).map(
								function(key) {
									return $scope.ratios[s][k][key];
								});


						mapobj.type = 'scatter';
						if (k != 'Tier 1 Capital Adequacy') {
							mapobj.yaxis = 'y2';
							mapobj.marker = {
								color : 'rgb(100,118,133)'
							};
						}
						if (k == 'Capital Adequacy Ratio') {

							mapobj.marker = {
								color : 'rgb(100,118,133)'
							};

						}
						if (k == 'Gross NPA / Loans & Advances') {

							mapobj.marker = {
								color : 'rgb(67,174,168)'
							};
						}
						if (k == 'Net NPA / Loans & Advances') {

							mapobj.marker = {
								color : 'rgb(104,129,186)'
							};
						}

						$scope.assetQuality.push(mapobj);

					}
					// Yash

				}

			}
			$scope.arrForDrillDownROE = [];

			$scope.arrForDrillDownROCE = [];

			$scope.params = [ 'ROE', 'ROCE' ];

			$scope.selectedparamName = {};

			$scope.selectedparamName.paraname = '';

			for ( var temp in $scope.drilldown) {

				Object.keys($scope.drilldown[temp]).forEach(
						function(k) {

							var obj = getObjForLineAndBarChart();

							obj.name = k;

							obj.x = Object.keys($scope.drilldown[temp][k]);
							obj.y = Object.keys($scope.drilldown[temp][k]).map(
									function(key) {
										return $scope.drilldown[temp][k][key];
									})// added by nibedita as Object.values
										// does
							// not supprt in IE

							obj.type = 'bar';

							if (k == 'RPAT' || k == 'Tangible Networth'
									|| k == 'ROE' || k == 'Operating Income') {

								if (k == 'ROE') {
									obj.type = 'scatter';
									obj.yaxis = 'y2';
								} else if (k == 'RPAT') {
									obj.marker = {
										color : 'rgb(131,184,170)'
									}
								} else if (k == 'Tangible Networth') {
									obj.marker = {
										color : 'rgb(100,118,133)'
									}
								} else if (k == 'Operating Income') {
									obj.marker = {
										color : 'rgb(100,118,133)'
									}
								}

								$scope.arrForDrillDownROE.push(obj);

							}

							else if (k == 'RPBT'
									|| k == 'Adj. Networth + Adj. Debt'
									|| k == 'ROCE') {

								if (k == 'ROCE') {
									obj.type = 'scatter';
									obj.yaxis = 'y2';
								} else if (k == 'RPBT') {
									obj.marker = {
										color : 'rgb(131,184,170)'
									}
								} else if (k == 'Adj. Networth + Adj. Debt') {
									obj.marker = {
										color : 'rgb(100,118,133)'
									}
								}

								$scope.arrForDrillDownROCE.push(obj);

							}


							$scope.plotBubbleChart = function(obj) {
								$scope.drillhide = true;
								if (obj == 'ROE') {
									$scope.drillhide = true;
									$scope.dataroe = $scope.arrForDrillDownROE;

								} else if (obj == 'ROCE') {

									$scope.drillhideroce = true;
									$scope.dataroce = $scope.arrForDrillDownROCE;

								} else if (obj == 'Overall') {
								
								}

							}

							$scope.layout3 = {

								height : 380,
								width : 480
							}


							var obj = 'ROE';


						});
			}
			if ($scope.arrForDrillDownROE.length > 0) {
				$scope.arrForDrillDownROE[0].name = "Reported PAT";// Nikhil
																	// Umale

			}
			if ($scope.arrForDrillDownROCE.length > 0) {
				$scope.arrForDrillDownROCE[0].name = "Reported PBT";// Nikhil
																	// Umale

			}
			$scope.dataroce = $scope.arrForDrillDownROCE;

			$scope.dataroe = $scope.arrForDrillDownROE;
	 		Object.keys($scope.dataforindustryindicators).forEach(function(k) {
				if ($scope.dataforindustryindicators[k].name == 'Revenue Growth' ) {
					$scope.dataforindustryindicators[k].x.splice(0, 1);
					$scope.dataforindustryindicators[k].y.splice(0, 1);

				}
			})


	}
		
		$scope.getNewSection = function(newsHeadline,id) {
			$state.go("industryProfileNews", {
				newsdata : $state.params.news,
				label : $state.params.label,
				industryId : $state.params.industryId || $window.localStorage.industryId,
				drill : $state.params.drill,
				indicator : $state.params.indicator,
				objtodisplay : $state.params.objtodisplay,
				movements : $state.params.movements,
				industryName : $state.params.industryName || $window.localStorage.industryName,
				industryAlertFlag : $state.params.industryAlertFlag,
				industryType : $state.params.industryType,
				companyYear : $state.params.companyYear,
				newsHeadline:newsHeadline,
				id:id,
				compObj:$stateParams.compObj || $window.localStorage.compObj
			});
		}
		
		// Modified for bug id 52027 till this line
		
		// Code added by Shrikant
		if ($stateParams.industryAlertFlag == '0' || $window.localStorage.industryAlertFlag) {
			$scope.alertAction = 'Set Alert';
			$scope.industryLevelAlertFlag = true;
		} else {
			$scope.alertAction = 'Remove Alert';
			$scope.industryLevelAlertFlag = false;
		}
		// code added by Deepali

		$scope.getAnnualIndustryData = function() {

			$scope.Id = $scope.industryId;
			industryService.getAggFinancials($scope.Id).then(
					function(response) {
						for (var i = 0; i < response[1].length; i++) {
							for(var j = 0; j < response[1][i].length; j++){
								if( response[1][i][j] == "∞" || response[1][i][j] == "Infinity"){
									response[1][i][j] = "n.m.";
								}
							}
						}
						$scope.listformovements = {};
						$scope.listformovements.upwards = response[0][0];
						$scope.listformovements.downwards = response[0][1];
						$scope.listformovements.mixed = response[0][2];

						$scope.showtopbottomperformersmain = true;

						$scope.outputParameters = response[1];

						
						$scope.dataForIndustryIndicator = response[2];

						$scope.dataForDrillDown = response[3];

						$scope.loaddir = true;
						if($scope.outputParameters.length==0){
							$scope.financialFlag="Annual  numbers are not available ";
						}
					}, function(error) {
					})
		}
		$scope.getQuaterlyIndustryData = function() {
			$scope.Id = $scope.industryId;
			{
				industryService.getAggQuaters($scope.Id).then(
						function(response) {

							$scope.listformovements = {};
							$scope.listformovements.upwards = response[0][0];
							$scope.listformovements.downwards = response[0][1];
							$scope.listformovements.mixed = response[0][2];
							
							for (var i = 0; i < response[1].length; i++) {
								for(var j = 0; j < response[1][i].length; j++){
									if( response[1][i][j] == "∞" || response[1][i][j] == "Infinity"){
										response[1][i][j] = "n.m.";
									}
								}
							}
							
							$scope.outputParameters = response[1];
							
							$scope.dataForIndustryIndicator = response[2];

							$scope.dataForDrillDown = response[3];
							
							if($scope.outputParameters.length==0){
								$scope.financialFlag="Quarterly  numbers are not available ";
							}
							
						}, function(error) {

						})
			}
		}
		// For saving recently viewed company
		$scope.saveRecentlyViewedCompanyForCompanyProfileModule = function(
				companyCode, moduleFlag) {

			CompanyProfileService
					.saveRecentlyViewedCompanyForCompanyProfileModule(
							companyCode, moduleFlag).success(function(result) {
					}).error(function(error) {
						//
					});

		}
		// end code by Deepali

		$scope.profitability = false;
		$scope.debt = true;
		$scope.drillhide = true;

		var X, Y;

		$scope.map = {
			center : {
				latitude : 21,
				longitude : 79
			},
			zoom : 4,
			options : {
				draggable : true,
				scrollwheel : true,
				zoomControlOptions : {
				}
			},

		};

		// Yash
		$scope.chgProfindicators = function() {
			$scope.drillhideroce = false;
			$scope.profitability = false;
			$scope.debt = false;
			$scope.drillhideroe = false;
			$scope.bank_assest = false;
			$scope.bank_profitability = true;

		}

		$scope.assestQualityIndicators = function() {
			$scope.drillhideroce = false;
			$scope.profitability = false;
			$scope.debt = false;
			$scope.drillhideroe = false;
			$scope.bank_assest = true;
			$scope.bank_profitability = false;

		}
		// Yash
		$scope.chgprofitibility = function() {

			$scope.bank_assest = false;
			$scope.bank_profitability = false;
			$scope.profitability = true;
			$scope.debt = false;
			$scope.drillhideroe = false;
			$scope.drillhideroce = false;

		}

		$scope.chgdebt = function() {
			$scope.bank_assest = false;
			$scope.bank_profitability = false;
			$scope.profitability = false;
			$scope.debt = true;
			$scope.drillhideroe = false;
			$scope.drillhideroce = false;

		}

		$scope.chgroe = function() {
			$scope.bank_assest = false;
			$scope.bank_profitability = false;
			$scope.profitability = false;
			$scope.debt = false;
			$scope.drillhideroe = true;
			$scope.drillhideroce = false;

		}

		$scope.chgroce = function() {
			$scope.bank_assest = false;
			$scope.bank_profitability = false;
			$scope.profitability = false;
			$scope.debt = false;
			$scope.drillhideroe = false;
			$scope.drillhideroce = true;

		}

		var getObjForLineAndBarChart = function() {
			return {
				x : [],
				y : [],
				name : '',
				type : ''
			}
		}

		$scope.layoutforcluster = {
			margin : {
				l : 60,
				r : 60,
				b : 30,
				t : 10,
				pad : 1,

			},
			height : 294,

		}

		$scope.layoutforroe = {
			margin : {
				l : 60,
				r : 60,
				b : 50,
				t : 10,
				pad : 1,

			},
			height : 300,
			width : 500,
			showlegend : true,
			 xaxis: {
				  type: 'category',
			 },
				"legend" : {
					"orientation" : "v",
					"x" : 1.09,
					"y" : 1,
					"xanchor" : "left",
					"yanchor" : "auto"
				},
			"yaxis" : {
				"tickfont" : {
					"color" : "#1f77b4"
				},
				"titlefont" : {
					"color" : "#1f77b4"
				},
				"title" : "Rs. Crore",
				"tickformat":'.3s'
			},
			"yaxis2" : {
				"tickfont" : {
					"color" : "#ff7f0e"
				},
				"title" : "%",
				"side" : "right",
				"overlaying" : "y",
				"titlefont" : {
					"color" : "#ff7f0e"
				},
				"anchor" : "x"
			}
		}

		$scope.layoutforprofitability = {
			margin : {
				l : 60,
				r : 60,
				b : 50,
				t : 10,
				pad : 1,

			},
			
		 	"legend" : {
				"orientation" : "v",
				"x" : 1.09,
				"y" : 1,
				"xanchor" : "left",
				"yanchor" : "auto"
			},
			height : 300,
			width : 500,
			showlegend : true,
			 xaxis: {
				  type: 'category',
			 },
			"yaxis" : {
				"tickfont" : {
					"color" : "#1f77b4"
				},
				"titlefont" : {
					"color" : "#1f77b4"
				},
				"title" : "%"
			},
			"yaxis2" : {
				"tickfont" : {
					"color" : "#ff7f0e"
				},
				"title" : "%",
				"side" : "right",
				"overlaying" : "y",
				"titlefont" : {
					"color" : "#ff7f0e"
				},
				"anchor" : "x"
			}
		}

		$scope.layoutfordebt = {
			margin : {
				l : 60,
				r : 60,
				b : 50,
				t : 10,
				pad : 1,

			},
			height : 300,
			width : 500,
			showlegend : true,
			"legend" : {
				"orientation" : "v",
				"x" : 1.09,
				"y" : 1,
				"xanchor" : "left",
				"yanchor" : "auto"
			},
			"yaxis" : {
				"tickfont" : {
					"color" : "#1f77b4"
				},
				"titlefont" : {
					"color" : "#1f77b4"
				},
				"title" : "Times"
			},
			"yaxis2" : {
				"tickfont" : {
					"color" : "#ff7f0e"
				},
				"title" : "Times",
				"side" : "right",
				"overlaying" : "y",
				"titlefont" : {
					"color" : "#ff7f0e"
				},
				"anchor" : "x"
			}
		}

		$scope.layoutforbankass = {
			margin : {
				l : 60,
				r : 60,
				b : 50,
				t : 10,
				pad : 1,

			},
			"legend" : {
				"orientation" : "v",
				"x" : 1.09,
				"y" : 1,
				"xanchor" : "left",
				"yanchor" : "auto"
			},
			height : 300,
			width : 900,
			showlegend : true,

			"yaxis" : {
				"tickfont" : {
					"color" : "#1f77b4"
				},
				"titlefont" : {
					"color" : "#1f77b4"
				},
				"title" : "%"
			},
			"yaxis2" : {
				"tickfont" : {
					"color" : "#ff7f0e"
				},
				"title" : "Times",
				"side" : "right",
				"overlaying" : "y",
				"titlefont" : {
					"color" : "#ff7f0e"
				},
				"anchor" : "x"
			}
		}

		$scope.layoutforbankprof = {
			margin : {
				l : 60,
				r : 60,
				b : 50,
				t : 10,
				pad : 1,

			},
			"legend" : {
				"orientation" : "v",
				"x" : 1.09,
				"y" : 1,
				"xanchor" : "left",
				"yanchor" : "auto"
			},
			height : 300,
			width : 900,
			showlegend : true,

			"yaxis" : {
				"tickfont" : {
					"color" : "#1f77b4"
				},
				"titlefont" : {
					"color" : "#1f77b4"
				},
				"title" : "Rs. Crore"
			},
			"yaxis2" : {
				"tickfont" : {
					"color" : "#ff7f0e"
				},
				"title" : "Times",
				"side" : "right",
				"overlaying" : "y",
				"titlefont" : {
					"color" : "#ff7f0e"
				},
				"anchor" : "x"
			}
		}
		$scope.industryType = '';
		$scope.getFinancialStats = function() {

			if ($scope.financial.type == "Count") {

				$timeout(function() {
					$scope.getQuaterlyIndustryData();
					
				}, 1000)

			} else if ($scope.financial.type == "Amount") {

				$timeout(function() {
					$scope.getAnnualIndustryData();
 				}, 1000)

			}

		}

	
		 
		$scope.getInsightDetailsForIndustryProfile = function() {
			InsightsService.getInsightDetailsForIndustryProfile(
					"Industry Profile", $scope.industryId).then(
					function(response) {
						
						$scope.dataInsights = response.data;

					});
		}

		$scope.getInsightDetailsForIndustryProfile();
		$scope.ratingInfoDetails = null;
		$scope.getRatingInfo = function() {

			industryService
					.getRatingDetails($scope.industryId)
					.then(
							function(response) {
								$scope.ratingInfoDetails = response;
								if ($scope.ratingInfoDetails.crisil != undefined) {
									$scope.ratingDis.company = "crisil";
								} else if ($scope.ratingInfoDetails.other != undefined) {
									$scope.ratingDis.company = "all";
								}
								if ($scope.ratingInfoDetails != null) {
									$scope.getRatingInfoByAgency();
								}

							}, function(reject) {
							})

		}
		$scope.getRatingInfoByAgencyForToggle = function() {
			if ($scope.ratingInfoDetails != null
					&& $scope.ratingDis.company != "") {

				$scope.getRatingInfoByAgency();
			 $scope.ratingDistributionCnt(); 
				
			}
		}
		$scope.getRatingInfoByAgency = function() {

			var ratingInfoList = [];
			if ($scope.ratingDis.company == 'crisil'
					&& $scope.ratingInfoDetails.crisil != undefined) {
				ratingInfoList = $scope.ratingInfoDetails.crisil;

			}
			if ($scope.ratingDis.company == 'all'
					&& $scope.ratingInfoDetails.other != undefined) {

				ratingInfoList = $scope.ratingInfoDetails.other;
				

			}

			if (ratingInfoList.length > 0) {
				
				$scope.getRatingInfoBy(ratingInfoList);

			}

		}

		$scope.getRatingInfoBy = function(agencyDetailList) {
			// $scope.dataToBeUsedForSixMonths is used for #48810
			$scope.dataToBeUsed = agencyDetailList[0];
			$scope.dataToBeUsedForSixMonths=[];	
			$scope.dataToBeUsed = agencyDetailList[0];
			var j=0;
			for(var i=0; i<agencyDetailList[0].length;i++){
					if(agencyDetailList[0][i].updateDate<=183){
						$scope.dataToBeUsedForSixMonths[j]=agencyDetailList[0][i];
						j++;
					}
			}
			
			$scope.uploadedDataList = {
				dataProvider : $scope.dataToBeUsedForSixMonths,
				styles : flexiciousNmsp.UIUtils.getThemeById('officeblue').styles,
				delegate : $scope

			};

			var uploadedlistGrid = '';
			$scope.uploadedlistcreation = function(event) {

				uploadedlistGrid = event.target;
				uploadedlistGrid.enableStickyControlKeySelection = true;
				uploadedlistGrid.setSelectionMode('singleRow');
				var cbCol = uploadedlistGrid.getColumns()[0];
				cbCol.radioButtonMode = true;
				uploadedlistGrid.excelOptions.exporters = [ new flexiciousNmsp.ExcelExporter() ];
				uploadedlistGrid.wordOptions.exporters = [ new flexiciousNmsp.DocExporter() ];
				uploadedlistGrid.validateNow();
				uploadedlistGrid.reDraw();

			};
			$scope.longtermcompanycount=[];
			$scope.longtermcompanycountForOthers=[];
			$scope.longTermRatingList=[];

			if($scope.ratingDis.company == 'all'){
				
			$scope.allRatingValue=Object.values(agencyDetailList[1]);
			angular.forEach($scope.allRatingValue[0], function(ratingVal) {
				if(ratingVal.ratingAgencyFlag !='crisil'){
					$scope.longTermRatingList.push(ratingVal);
					
				}
			});
			$scope.longtermcompanycount.push($scope.longTermRatingList);
			}else{
				$scope.longtermcompanycount=Object.values(agencyDetailList[1]);
			}
	
			$scope.longtermratingamount = Object.values(agencyDetailList[2]);
			$scope.shorttermcompanycount = Object.values(agencyDetailList[3]);

			$scope.shorttermratingamount = Object.values(agencyDetailList[4]);

			var objForCountLong = {
				x : '',
				y : '',
				type : ''
			};

			var xval = [];
			var yval = [];

			if($scope.ratingDis.company== 'crisil'){
			$scope.longtermcompanycount[0].forEach(function(k) {

				xval.push(k.rating);
				yval.push(k.count);
			});
			}else{
				$scope.longtermcompanycount[0].forEach(function(l) {
				
					xval.push(l.rating);
					yval.push(l.count);
					
				});
				
			}

			objForCountLong.x = xval;
			objForCountLong.y = yval;
			objForCountLong.type = 'bar';

			$scope.dataforratingdistribution = [];

			$scope.dataforratingdistribution.push(objForCountLong);

			$scope.layoutforratingdistribution = {
				margin : {
					l : 70,
					r : 40,
					b : 50,
					t : 10,
					pad : 0,
				},
				height : 294,
				yaxis : {
					title : '',
					titlefont : {
						size : 16,
						color : 'rgb(107, 107, 107)'
					},

				},
			};

			if ($scope.ratingDis.count == 'Count'
					&& $scope.ratingDis.long == 'Long') {
				$scope.layoutforratingdistribution.yaxis.title = 'Number of Companies';
			} else if ($scope.ratingDis.count == "Amount"
					&& $scope.ratingDis.long == "Long") {
				$scope.layoutforratingdistribution.yaxis.title = 'Rated Debt (Rs crore)';
			}

		
			$scope.oneyearobj = null;
			$scope.twoyearobj = null;
			$scope.threeyearobj = null;
			$scope.showpie = false;

			Object
					.keys($scope.dataToBeUsed)
					.forEach(
							function(k) {

								var funcObjTbl = function() {
									return {
										label : '',
										cntup : 0,
										cntdown : 0
									}
								}
								
								
								if	(parseInt($scope.dataToBeUsed[k].updateDate) <= 365) {

									if ($scope.oneyearobj == null) {

										$scope.oneyearobj = funcObjTbl();
										$scope.oneyearobj.label = '1 year'

									}

									if ($scope.dataToBeUsed[k].ratingAction == 'Upgraded') {

										$scope.oneyearobj.cntup++;

									} else if ($scope.dataToBeUsed[k].ratingAction == 'Downgraded') {

										$scope.oneyearobj.cntdown++;

									}

								} else if (parseInt($scope.dataToBeUsed[k].updateDate) > 365
										&& parseInt($scope.dataToBeUsed[k].updateDate) <= 730) {

									if ($scope.twoyearobj == null) {

										$scope.twoyearobj = funcObjTbl();
										$scope.twoyearobj.label = '1-2 years'

									}

									if ($scope.dataToBeUsed[k].ratingAction == 'Upgraded') {

										$scope.twoyearobj.cntup++;
									} else if ($scope.dataToBeUsed[k].ratingAction == 'Downgraded') {

										$scope.twoyearobj.cntdown++;

									}

								} else if (parseInt($scope.dataToBeUsed[k].updateDate) > 730
										&& parseInt($scope.dataToBeUsed[k].updateDate) <= 1095) {

									if ($scope.threeyearobj == null) {

										$scope.threeyearobj = funcObjTbl();
										$scope.threeyearobj.label = '2-3 years'
									}

									if ($scope.dataToBeUsed[k].ratingAction == 'Upgraded') {

										$scope.threeyearobj.cntup++;

									} else if ($scope.dataToBeUsed[k].ratingAction == 'Downgraded') {

										$scope.threeyearobj.cntdown++;

									}

								}

							})

		}
		//
// Error Code
		
		$scope.getClusterInformation = function() {

			industryService.getClusterInfo($scope.industryId).then(

			function(response) {

				var getObjForMap = function() {

					return {
						id : "Hyderabad",
						icon : 'content/images/dis_icon.png',
						coords : {
							latitude : "17.385",
							longitude : "78.4867"
						},
						window : {
							title : "Hyderabad"
						}
					};
				}

				$scope.districts = response.data;

				var arrOfMarkers = [];

				$scope.districts.forEach(function(k) {

					var temp = getObjForMap();

					temp.coords.latitude = k.latitude;
					temp.coords.longitude = k.longitude;
					temp.window.title = k.dist;
					temp.id = k.dist;
					arrOfMarkers.push(temp);

				})


				$scope.map = {
					center : {
						latitude : 21,
						longitude : 79
					},
					zoom : 4,
					options : {
						draggable : true,
						scrollwheel : false,
						disableDefaultUI : false,
						zoomControlOptions : {
						
						}
					},

				};
				$scope.markers = arrOfMarkers;
			}, function(reject) {

			}

			)
		}

		$scope.clusterarr = [];

		$scope.showClusterChar = false;

		$scope.plotclusterchart = function(temp) {

$scope.modebarOptions = {
				showLink : false,
				displaylogo : false,
				modeBarButtonsToRemove : ['sendDataToCloud','zoom2d','pan2d','select2d','lasso2d','zoomIn2d','zoomOut2d','autoScale2d','toggleSpikelines','hoverClosestCartesian','hoverCompareCartesian']
			};
			$scope.clusterarr = [];
			
		
			var obj = getObjForLineAndBarChart();
			
			obj.x = Object.keys($scope.clusterParams[temp]);
			obj.y = Object.values($scope.clusterParams[temp]);
			obj.name = temp;
			obj.type = 'bar';
			obj.marker = {
				color : [ 'rgb(131,184,170)', 'rgb(131,184,170)',
						'rgb(131,184,170)', 'rgb(131,184,170)',
						'rgb(131,184,170)' ]
			};

			$scope.clustertitle = temp;

			$scope.clusterarr.push(obj);
			if ($scope.clusterarr.length > 0) {

				$scope.showClusterChar = true;
			} else {
				$scope.showClusterCharerr = true;
			}
			if ($scope.clustertitle == "Net Sales"
					|| $scope.clustertitle == "Operating Income"
					|| $scope.clustertitle == "OPBDIT"
					|| $scope.clustertitle == "PAT"
					|| $scope.clustertitle == "Net Cash Accruals"
					|| $scope.clustertitle == "Equity Share Capital"
					|| $scope.clustertitle == "Adjusted Networth"
					|| $scope.clustertitle == "Adjusted Debt"
					|| $scope.clustertitle == "Cashflow from operations") {
				$scope.layoutforcluster.yaxis = {
					"type" : "linear",
					"range" : [],
					"title" : "Rs. Lakh",
				};
			} else {
				$scope.layoutforcluster.yaxis = {
					"type" : "linear",
					"range" : [],

				};
			}
			var range = [];
			var maxNumber = 0;

			var minNum = 0;

			maxNumber = $scope
					.getMaxScaleNber($scope.clusterParams[temp], 1000);
			minNum = $scope.getMinScaleNber($scope.clusterParams[temp], 1000);

			if (minNum >= 0.0) {

				range = [ 0, maxNumber ]
			} else {
				range = [ minNum, maxNumber ]
		}

			$scope.layoutforcluster.yaxis.range = range;
		}
		$scope.getMaxScaleNber = function(list, value) {
			var maxArray = [];
			angular.forEach(list, function(value1) {
				var v = value1 + "";
				maxArray.push(parseFloat(v.replace(",", "")));
			});

			var maxValue = Math.max.apply(Math, maxArray);
			if (maxValue >= 0 && maxValue < 0.2) {
				return maxValue + 0.5;

			} else if (maxValue >= 0.2 && maxValue < 10) {
				return maxValue + 1;

			} else if (maxValue >= 10 && maxValue < 100) {
				return maxValue + 10;
			} else if (maxValue >= 100 && maxValue < 1000) {
				return maxValue + 100;
			} else if (maxValue <= 0 && maxValue < -0.2) {
				return maxValue - 1;
			} else if (maxValue <= -0.2 && maxValue < -10) {
				return maxValue - 1;
			} else if (maxValue <= -10 && maxValue < -100) {
				return maxValue - 10;
			} else if (maxValue <= -100 && maxValue < -1000) {
				return maxValue - 100;
			} else {

				maxValue = maxValue + value;
				$scope.layoutforcluster.yaxis.autorange = true;
			}

			if (maxValue > -0.0) {
				return maxValue;
			} else {
				maxValue = maxValue - value;
				return maxValue;
			}

		}

		$scope.getMinScaleNber = function(list, value) {
			var minArray = [];
			angular.forEach(list, function(value1) {
				var v = value + "";
				minArray.push(parseFloat(v.replace(",", "")));
			});

			var minValue = Math.min.apply(Math, minArray);
			if (minValue < -0.0) {
				return minValue - value;
			} else {
				return minValue;
			}

		}
	// save
		$scope.pinClicked = function(cityName) {
		
			$scope.clusterinfohide = false;

			$scope.showClusterChar = false;

			// $scope.industryId = $scope.industryId;

			$scope.clusterarr = [];

			$scope.clusterparams = [];

			$scope.selectedclusterparamName = {};

			$scope.selectedclusterparamName.paraname = '';

					industryService
							.getClusterInfoByIndustryName($scope.industryId,
									cityName)
							.then(
									function(response) {

										var getClusterChars = function() {
											return {
												propname : '',
												value : ''
											};
										}

										var arrXvalue = [];

										$scope.clusterParams = response.data[0];
										$scope.clusterchars = response.data[2];
										$scope.arrOfClusterChars = [];

										$scope.clustercharserr = false;
										$scope.clusterinfohide = true;

										if ($scope.clusterchars != undefined) {

											Object
													.keys($scope.clusterchars)
													.forEach(
															function(k) {

																var obj = getClusterChars();
																obj.propname = k;

																if (k == 'Revenue') {

																	if ($scope.clusterchars[k] == "Revenue not available") {

																		obj.value = $scope.clusterchars[k]

																	} else {

																		obj.value = $scope.clusterchars[k]
																				+ ' Cr';

																	}

																} else if (k == 'EBDITA Margin') {

																	if (isNaN($scope.clusterchars[k])) {
																		obj.value = $scope.clusterchars[k];
																	} else {
																		obj.value = $scope.clusterchars[k]
																				+ ' %';
																	}

																} else if (k == 'Asset Turnover') {

																	if (isNaN($scope.clusterchars[k])) {
																		obj.value = $scope.clusterchars[k];
																	} else {
																		obj.value = $scope.clusterchars[k]
																				+ ' Times';
																	}

																} else {
																	obj.value = $scope.clusterchars[k];
																}

																$scope.arrOfClusterChars
																		.push(obj);

															})

											$scope.clustercharsmsg = true;

										} else {
											$scope.clustercharserr = true;
										}

										$scope.showkeyplayers = false;

										if (Object.keys(response.data[1]).length > 0) {
											$scope.keyPlayers = Object
													.keys(response.data[1]);
										} else {
											$scope.keyPlayers = undefined;
										}

										if ($scope.keyPlayers != undefined) {

											if (Object.keys($scope.keyPlayers).length > 1) {
												$scope.showkeyplayerserr = false;
												$scope.showkeyplayers = true;
												$scope.showkeyplayerserrforcount = false;
											} else if(Object.keys($scope.keyPlayers).length == 1) {
												$scope.showkeyplayerserr = false;
												$scope.showkeyplayerserrforcount  = false;
												$scope.showkeyplayers = true;
											}else{
												
												$scope.showkeyplayerserr = true;
												$scope.showkeyplayerserrforcount  = false;
												$scope.showkeyplayers = false;
											}

										} else {
											$scope.showkeyplayerserr = true;
										}

										if ($scope.clusterParams != undefined) {

											for ( var temp in $scope.clusterParams) {

												$scope.clusterparams.push(temp);
											}

											$timeout(
													function() {
														$scope
																.plotclusterchart($scope.clusterparams[0]);

													}, 100);

											$scope.selectedclusterparamName.paraname = $scope.clusterparams[0];
											$timeout(
													function() {
														$scope
																.plotclusterchart($scope.clusterparams[0]);
													}, 100);

										} else {
											$scope.showClusterCharerr = true;
											$scope.clusterinfohide = false;
										}

									}, function(reject) {

									}), function(error) {

					};

		}
		$scope.companyCode='';
		$scope.getCompaniesListByNameNew = function(companyNameToview) {
			// Not used company code to get flag as from key opr param not
			// getting companyCode
			var promise = GenericServiceNew
			.getCompaniesListByNameNew(companyNameToview,
					"COMPANYPROFILE");
			promise.then(
					function(data) {
						$scope.companies = data;
						
						$scope.companyCode= $scope.companies[0].companyCode;
						if ($scope.companies[0].companyFlag != 'SME' &&
								 $scope.companies[0].companyFlag != 'NSIC'){
									var paramsValue = {
											'companyCode' : $scope.companyCode,
											'flag' : $scope.companies[0].companyFlag,
											'companyName' : companyNameToview
										};
								var url = $state.href('companyDetails');
								$window.localStorage['companyCodeToRedirect']=JSON
								.stringify(paramsValue);
								$window.open(url,'_blank');
							}else{
								var paramsValue = {
										'companyCode' : $scope.companyCode,
										'flag' : $scope.companies[0].companyFlag
									};
								var url = $state.href('smeDetails');
								$window.localStorage['companyCodeToRedirect']=JSON
								.stringify(paramsValue);;
								$window.open(url,'_blank');
							}
								
					});
			
			
		}

		$scope.city = "";
		$scope.pinClicked($scope.city);

		$scope.ratingDis = {};

		$scope.ratingDis.count = 'Count';
		$scope.ratingDis.long = 'Long';
		$scope.ratingDis.company = 'crisil';

		$scope.ratingDistributionCnt = function() {

			$scope.dataforratingdistribution = [];

			var getObjForRatingDistribution = function() {
				return {
					x : '',
					y : '',
					type : ''
				}
			}

			$timeout(
					function() {

						if ($scope.ratingDis.count == 'Count'
								&& $scope.ratingDis.long == 'Long') {

							$scope.layoutforratingdistribution.yaxis.title = 'Number of Companies';

							var objForCountLong = getObjForRatingDistribution();

							var xval = [];
							var yval = [];

							$scope.longtermcompanycount[0].forEach(function(k) {
								xval.push(k.rating);
							});

							$scope.longtermcompanycount[0].forEach(function(k) {
								yval.push(k.count);
							});

							objForCountLong.x = xval;
							objForCountLong.y = yval;
							objForCountLong.type = 'bar';
							objForCountLong.marker = {
								color : 'rgb(131,184,170)'
							};

							$scope.dataforratingdistribution
									.push(objForCountLong);

						} else if ($scope.ratingDis.count == "Amount"
								&& $scope.ratingDis.long == "Long") {

							$scope.layoutforratingdistribution.yaxis.title = 'Rated Debt (Rs crore)';
							var objForAmountLong = getObjForRatingDistribution();

							var xval = [];
							var yval = [];

							$scope.longtermratingamount[0].forEach(function(k) {
								xval.push(k.rating);
							});

							$scope.longtermratingamount[0].forEach(function(k) {
								yval.push(k.count);
							});

							objForAmountLong.x = xval;
							objForAmountLong.y = yval;
							objForAmountLong.type = 'bar';
							objForAmountLong.marker = {
								color : 'rgb(131,184,170)'
							};

							$scope.dataforratingdistribution
									.push(objForAmountLong);

						} else if ($scope.ratingDis.count == 'Count'
								&& $scope.ratingDis.long == 'Short') {

							$scope.layoutforratingdistribution.yaxis.title = 'Number of Companies';
							var objForCountShort = getObjForRatingDistribution();

							var xval = [];
							var yval = [];

							$scope.shorttermcompanycount[0]
									.forEach(function(k) {
										xval.push(k.rating);
									});

							$scope.shorttermcompanycount[0]
									.forEach(function(k) {
										yval.push(k.count);
									});

							objForCountShort.x = xval;
							objForCountShort.y = yval;
							objForCountShort.type = 'bar';
							objForCountShort.marker = {
								color : 'rgb(131,184,170)'
							};

							$scope.dataforratingdistribution
									.push(objForCountShort);

						} else if ($scope.ratingDis.count == 'Amount'
								&& $scope.ratingDis.long == 'Short') {

							$scope.layoutforratingdistribution.yaxis.title = 'Rated Debt (Rs crore)';
							var objForAmountShort = getObjForRatingDistribution();

							var xval = [];
							var yval = [];

							$scope.shorttermratingamount[0]
									.forEach(function(k) {
										xval.push(k.rating);
									});

							$scope.shorttermratingamount[0]
									.forEach(function(k) {
										yval.push(k.count);
									});

							objForAmountShort.x = xval;
							objForAmountShort.y = yval;
							objForAmountShort.type = 'bar';
							objForAmountShort.marker = {
								color : 'rgb(131,184,170)'
							};

							$scope.dataforratingdistribution
									.push(objForAmountShort);

						} else {
							alert("No match found");

						}

						$scope.loadratinglongshort = true;

					}, 100)

					 
		}

		$scope.clicked = function(obj, cnt) {
			$scope.myvalue = false;

			if (obj == 'Companies with 1 year' && cnt == 'cntup') {

				var arr = $scope.dataToBeUsed.filter(function(k) {
					if (k.updateDate <= 365 && k.ratingAction == 'Upgraded') {
						return k;
					}
				})

				var objpush = {
					'companyName' : "The KCP Limited",
					'movementReason' : "Denomination",
					'rating' : "CRISIL A-",
					'ratingAction' : "Upgraded",
					'updateDate' : "344"
				}

				var objpush2 = {
					'companyName' : "The KCP Limited",
					'movementReason' : "Policy Change",
					'rating' : "CRISIL A-",
					'ratingAction' : "Upgraded",
					'updateDate' : "344"
				}

				var objpush3 = {
					'companyName' : "The KCP Limited",
					'movementReason' : "Denomination",
					'rating' : "CRISIL A-",
					'ratingAction' : "Downgraded",
					'updateDate' : "344"
				}

				arr.push(objpush);
				arr.push(objpush2);
				arr.push(objpush3);

				var setObj = new Set();
				var values = [];
				var label = [];

				$scope.elems = {};

				arr.forEach(function(k) {

					setObj.add(k.movementReason);

				})

				setObj.forEach(function(k) {

					var mvncnt = 0;
					label.push(k);
					arr.forEach(function(temp) {

						if (temp.movementReason == k) {
							mvncnt++;

						}
					})

					var tempObj = arr.filter(function(j) {
						if (j.movementReason == k) {
							return j;
						}
					})

					values.push(mvncnt);

					$scope.elems[k] = tempObj;

				})

				$scope.objofpie = {};
				$scope.objofpie.values = values;
				$scope.objofpie.labels = label;
				$scope.objofpie.type = 'pie'

				$scope.arrforpie = [];

				$scope.arrforpie.push($scope.objofpie);

			}
			$scope.showpie = true;
			var toCompare = null;

		}

		$scope.reset = function() {

			$scope.showpie = false;

		}

		$scope.layoutforpie = {

			margin : {
				l : 10,
				r : 10,
				b : 20,
				t : 10,
				pad : 5,
			},

			height : 290,

		};

		$scope.irsFunction = function() {
			if ($scope.industryType == 20 || $scope.industryType == 21  ) {

				$scope.clusterhide = true;

			} else if ($scope.industryType == 19 || $scope.industryType == 18) {
				if($scope.indRiskScore == undefined){
					$scope.clusterhide = true;
				// $scope.irsIndAttrsHide = true;
					$scope.showirs = false;
					
				} else if ($scope.indRiskScore[0].indScore == null
						&& $scope.indRiskScore[2].indScore == null
						&& $scope.indRiskScore[3].indScore == null
						&& $scope.indRiskScore[4].indScore == null
						&& $scope.indRiskScore[6].indScore == null) {
					$scope.clusterhide = true;
					// $scope.irsIndAttrsHide = true;
					$scope.showirs = false;
				}
			}
			}
		
		$scope.getAllIndustryData = function() {
			
			$scope.loadingRatingTrend = true;
			industryService
					.getIndustryInfo($state.params.industryId || $window.localStorage.industryId)
					.then(
							function(response) {
                            
								
                             
								$scope.loadingRatingTrend = false;

								var i = 2;
								var arrayformulti = [];

								var totlen = response.data.length;

								if (response.data.length > 2) {

									$scope.defaultvalforind = response.data[response.data.length - 1];

									while (i < response.data.length - 1) {

										var obj = response.data[i];

										arrayformulti.push(obj);

										i++;
									}

								}
						
								$scope.namesofmultipleirs = [];

								$scope.arrofindwithdetails = [];

								Object
										.keys(arrayformulti)
										.forEach(
												function(val) {

													var obj = Object
															.keys(arrayformulti[val]);

													var objname = obj[0];

													$scope.namesofmultipleirs
															.push(obj[0]);

													var objcr = {};

													objcr[objname] = Object
															.values(arrayformulti[val]);

													$scope.arrofindwithdetails
															.push(objcr);

												})

								$scope.showirs = false;

								$scope.arrayOfIndustryParams = new Array();
								$scope.arrayOfMedianRatingObjs = new Array();
								$scope.temparrayOfMedianRatingObjs = new Array();

								Object
										.keys(response.data[1])
										.forEach(
												function(val) {

													$scope.arrayOfMedianRatingObjs
															.push(response.data[1][val]);
												})

								$scope.objformedianrating = {

									theme : 'black',
									type : 'serial',
									data : $scope.arrayOfMedianRatingObjs,
									valueAxes : [ {
										unit : "",
										position : "left",
										labelsEnabled : false,
										title : "Median Rating",

									} ],
									startDuration : 1,
									graphs : [ {
										"id" : "g1",
										"balloon" : {
											"drop" : true,
											"adjustBorderColor" : false,
											"color" : "#ffffff"
										},
										"bullet" : "circle",
										"bulletBorderAlpha" : 1,
										"bulletColor" : "#eecfba",
										"bulletSize" : 7,
										"hideBulletsCount" : 50,
										"lineThickness" : 4,
										"title" : "red line",
										"useLineColorForBulletBorder" : true,
										"valueField" : "scale",
										"lineColor" : "#eecfba",
										"balloonText" : "<span class='font-size-12'>[[medianRating]]</span>"
									} ],
									
									categoryField : "month",
									categoryAxis : {
										gridPosition : "start",
										parseDates : false,
										labelRotation : 45,
									},

									export : {
										enabled : false
									}

								}

								Object
										.keys(response.data[0])
										.forEach(
												function(val) {

													var getProtoForScoreObj = function() {
														return {
															indScore : '',
															riskEntName : '',
															indComments : ''
														}
													}

													var obj = getProtoForScoreObj();

													Object
															.keys(
																	response.data[0][val])
															.forEach(
																	function(k) {

																		obj[k] = response.data[0][val][k];

																	});

													$scope.arrayOfIndustryParams
															.push(obj);

												});

								if (response.data[0].length != 0) {
									$scope.showirs = true;
									$scope.loadmedianRating = true;
									$scope.indRiskScore = response.data[0];
								}

								if (response.data[1].length != 0) {

									$scope.loadmedianRating = true;
								}
								$scope.irsFunction();
								
							}, function(error) {
								
							})

		}
		
		

		$scope.ratingAction = function(rowData, column) {

			if (rowData.ratingAction == 'Upgraded') {

				var html = '<i class="fa fa-arrow-up upload-color" title="Upgraded" ></i>';
				
			} else if(rowData.ratingAction == 'Downgraded'){

				var html = '<i  class="fa fa-arrow-down remove-color" title="Downgraded" ></i>';
				
			}else{
				var html="";
			}
			
			return html;


		}

	
		// yash

		$scope.constituentData = [];
		$scope.addFinancialsFlag = false;
		$scope.constituentHeader = [];


		$scope.paginationConstituent = function(page){
								$scope.companyListdata = [];
								angular.forEach($scope.constituentData,
										function(data) {
											$scope.companyListdata
													.push(data.company_CODE);
										});

			if($scope.addFinancialsFlag == false){
								$scope.industryType = $scope.constituentData[0].industry_type;
			}
			
								$scope.totalConstituents = parseInt($scope.constituentData[1].total_constituents_count);
										
								$scope.totalPages = $scope.constituentData[1].total_constituents_count / 10;
			$scope.pages = Math.ceil($scope.totalPages);

								$scope.numArray = [];
								$scope.firstVal = null;

			for (var i = 1; i <= $scope.pages; i++) {
									$scope.numArray.push(i);
								}
								$scope.firstVal = page;
		}
		

		$scope.getConstituentData = function(page) {
			$scope.showFinanceBtn = true;
			$scope.constituentData = [];
			$scope.addFinancialsFlag = false;
			$scope.constituentHeader = [ 'Company Name', 
					'Rating Agency', 'Rating Type', 'Rating',
					'Rating Outlook', 'LongTerm  Amount(Rs.Crore)', 'ShortTerm  Amount(Rs.Crore)',
					'Rating Action', 'PR Date', 'CRR Date' ];

			var industryId = $scope.industryId;
			industryService
					.getConstituentInfo(page, industryId)
					.then(
							function(response) {
								$scope.constituentData = response.data;
								
								$scope.paginationConstituent(page);
								
							}, function(error) {

							})

		}

	
		Array.prototype.getUniqueCompany = function(createArray) {
			createArray = createArray === true ? true : false;
			var temp = JSON.stringify(this);
			temp = JSON.parse(temp);
			if (createArray) {
				var unique = temp.filter(function(elem, pos) {
					return temp.indexOf(elem) == pos;
				}.bind(this));
				return unique;
			} else {
				var unique = this.filter(function(elem, pos) {
					return this.indexOf(elem) == pos;
				}.bind(this));
				this.length = 0;
				this.splice(0, 0, unique);
			}
		}


		$scope.SavePortfolio = function(portfolioName) {
			if (portfolioName != null && portfolioName != "") {

				$http({
					url : 'api/portfolio/portfolioNameValidation',
					method : 'POST',
					data : portfolioName,
				})
						.success(
								function(data) {

									if (data[0] === 'TRUE') {
										$scope.validatePortfolio = 'Portfolio already exists with name '
												+ portfolioName + '';

									} else {

										$scope.companyList = [];

										$scope.companyList
												.push($scope.companyListdata);

										$scope.inputData = {
											id : null,
											name : portfolioName,
											spreadData : '',
											uploadFlag : 'N',
											isDeleted : 'N',
											companyData : $scope.companyListdata,
											isShared : 'Y'
										}

										$http(
												{
													url : 'api/portfolioresource/addPortfolio',
													method : 'POST',
													data : $scope.inputData,
												}).success(function(data) {
											$scope.successPortfolio = 'OK';
											$scope.cancel();

										}, function(error) {
										});

									}
								}, function(error) {

								});
			}

			else {
				$scope.validatePortfolio = "Portfolio Name is Required.";

			}
		}


		$scope.upatePortfolio = function(updatePortfolio) {

			if (updatePortfolio.name != null && updatePortfolio.name != "") {

				$scope.updatecompanyList = [];

		
				$scope.companyListdata.getUniqueCompany();

				$scope.inputData = {
					id : updatePortfolio.id,
					name : updatePortfolio.name,
					spreadData : '',
					uploadFlag : 'N',
					isDeleted : 'N',
					companyData : $scope.companyListdata,
					isShared : 'Y'
				}

				$http({
					url : 'api/portfolioresource/addPortfolio',
					method : 'POST',
					data : $scope.inputData,
				}).success(function(data) {
					$scope.successPortfolio = 'OK';

				}, function(error) {
				});

			}

			else {
				$scope.validatePortfolio = "Portfolio Name is Required.";

			}
		}


		$scope.getListPortfolio = function() {
			$scope.shows = true;
			$scope.validatePortfolio = "";
			$http({
				url : 'api/portfolioresource/getListPortfolio',
				method : 'POST',
			}).success(function(data) {
				$scope.ListPortfolio = data;

			}).error(function(response) {
			});
		}


		$scope.addFinancials = function(page) {
			// added by 47133
			$scope.showFinanceBtn = false;
			$scope.addFinancialsFlag = true;
		
			$scope.goTo = false;
			$scope.mfgFinancials = ['Year End', 'Net Sales(In Lakhs)',
					'Operating Income(In Lakhs)', 'OPBDIT(In Lakhs)',
					'PAT(In Lakhs)', 'Net Cash Accruals(In Lakhs)',
					'Equity Share Capital(In Lakhs)',
					'Adjusted Networth(In Lakhs)', 'Adjusted Debt(In Lakhs)',
					'OPBDIT Margin(%)', 'Net Profit Margin(%)', 'ROCE(%)',
					'PBDIT / Interest & Finance Charges(Times)',
					'Net Cash Accruals / Adjusted Debt(Times)',
					'Adjusted Debt / Adjusted Networth(Times)',
					'Adjusted Debt / PBDIT(Times)', 'Current Ratio(Times)',
					'Total Oustside Liabilities / Adjusted Networth(Times)',
					'Cash Flow from Operations(In Lakhs)',
					'Operating Income / Gross Block(Times)',
					'Gross Current Asset Days' ];
		
			$scope.bnkFinancials = ['Year End', 'Deposits', 'Advances', 'Invesments',
					'Networth (tangible)', 'Total assets (adjusted)',
					'Net interest income', 'Other income',
					'Total income (net of interest expenses)',
					'Operational expenses', 'Provisions and contingencies',
					'Reported PAT', 'Net Interest Income / Avg. Total Assets',
					'Non Int. Expense / Avg. Total Assets',
					'RPAT / Avg. Total Assets', 'RPAT / Avg. Networth',
					'Interest Paid on Deposits / Average Deposits',
					'Gross NPA / Gross Advances', 'Net NPAs / Net Advances',
					'Capital Adequacy Ratio', 'Networth / Net NPAs' ];
		
			$scope.nbfcFinancials = [ 'Year End','Equity Capital', 'Adjusted Networth',
					'AUM', 'Disbursements', 'Total assets', 'Total borrowing',
					'Interest Income', 'Interest expenses',
					'Total income (net of interest expenses)',
					'Operating expenses (incl. depreciation)', 'Provisions',
					'Profit after tax',
					'Interest expenses / average borrowing',
					'Return on networth', 'Adjusted gearing', 'Gross NPA',
					'Net NPA', 'Overall CAR', 'Networth / Net NPA' ];
			industryService.getFinancialsInfo(page, $scope.industryId,
					$scope.industryType).then(function(response) {

				$scope.constituentData = response.data;
				
				$scope.paginationConstituent(page);
				
			}, function(error) {
			})
			if ($scope.industryType == '18' || $scope.industryType == '19') {
				$scope.mfgFinancials.forEach(function(k) {
					$scope.constituentHeader.push(k);

				})
			}
			if ($scope.industryType == '20') {
				$scope.bnkFinancials.forEach(function(k) {
					$scope.constituentHeader.push(k);

				})
			}
			if ($scope.industryType == '21') {
				$scope.nbfcFinancials.forEach(function(k) {
					$scope.constituentHeader.push(k);

				})
			}

		}
		$scope.removeFinancials = function(page) {
			$scope.showFinanceBtn = true;
			$scope.addFinancialsFlag = false;
			$scope.goTo = false;
			$scope.reopenConstitutent('cons', page);
			$scope.constituentHeader = [ 'Company Name', 
					'Rating Agency', 'Rating Type', 'Rating',
					'Rating Outlook', 'LongTerm  Amount(Rs.Crore)', 'ShortTerm  Amount(Rs.Crore)',
					'Rating Action', 'PR Date', 'CRR Date' ];
		}

	
		// yash

		$scope.getRatingInfo();

		$scope.getClusterInformation();

		$scope.dismiss = function() {

			$('#showCompanies').modal('hide');

		}

		$scope.closePloty = function() {
			$scope.myvalue = true;
			$scope.showpie = false;

		};
		$scope.plotlyEventsForCompanies = function(graph) {

			graph.on('plotly_click', function(event) {

				$scope.reason = event.points[0].label;

				/*
				 * $scope.elems.forEach(function(key){ if(key ==
				 * event.points[0].label){ $scope.companyDetails =
				 * $scope.elems[key]; } })
				 */

				for ( var key in $scope.elems) {

					if (key == event.points[0].label) {
						$scope.companyDetails = $scope.elems[key];
					}

				}

				$scope.$digest();

				$('#showCompanies').modal('show');

			})

		}



		$scope.openAlertPopUp = function() {

			$scope.industryAlertPopUpData = {
				industryId : $scope.industryId,
				industryName : $stateParams.industryName || $window.localStorage.industryName,
				portfolioId : '',
				isIndustryLevel : 'Y',
				isPortfolioLevel : 'N',
				isCompanyLevel : 'N'
			};

			if ($scope.industryLevelAlertFlag) {
				$scope.setIndAlertStatus = false;
				$uibModal
						.open({

							templateUrl : 'app/alert components/set alert/industryLevelAlert.html',
							controller : 'IndustryLevelAlertController',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								companyData : function() {
									return $scope.industryAlertPopUpData;
								},
								controllerModule : function() {
									return 'industryProfileDetailsController';
								},
								parentAccess : function() {
									return $scope;
								}
							}
						}).closed.then(function() {
					if ($scope.setIndAlertStatus) {
						$scope.alertAction = 'Remove Alert';
						$scope.industryLevelAlertFlag = false;
					}
				});
			} else {
				$scope.removeIndAlertStatus = false;
				$uibModal
						.open({
							templateUrl : 'app/alert components/remove alert/removeAlert-dialog.html',
							controller : 'RemoveAlertDialogController',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								alertNameFor : function() {
									return $stateParams.industryName || $window.localStorage.industryName;
								},
								companyData : function() {
									return $scope.industryAlertPopUpData;
								},
								selectedForAll : function() {
									return 'NA';
								},

								selectedForAlertList : function() {
									return [];
								},
								searchedText : function() {
									return 'NA';
								},
								controllerModule : function() {
									return 'industryProfileDetailsController';
								},
								parentAccess : function() {
									return $scope;
								}
							}
						}).closed.then(function() {
					if ($scope.removeIndAlertStatus) {
						$scope.alertAction = 'Set Alert';
						$scope.industryLevelAlertFlag = true;
					}

				});

			}

		}

		// added by srinivas
		$scope.downloadTemplate = function() {
			if (sectionaccess["Industry Profile.Export Industry Profile"] != 'Y') {
				$scope.error = true;
				$scope.errorMessages = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
				$timeout(function() {

					$scope.error = false;
					$scope.errorMessage = "";

				}, 2000);
			} else {
				$scope.exportInputDTO = {
					inputId : $scope.industryId
				};
				$http({
					url : 'api/industry/industryExcelExportData',
					method : 'POST',
					data : $scope.exportInputDTO,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {
									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'IndustryProfile.xlsx');

									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										
										angular.element(document.body).append(
												anchor); // Attach to
										// document
										anchor.attr({
											href : objectUrl,
											target : '_self',
											download : 'IndustryProfile.xlsx'
										})[0].click();

										anchor.remove();

									}

								})["catch"](function(response) {

								});
			}

		}

		// code added by Nikhil Umale
		$scope.reopenConstitutent = function(flag, page) {
			$scope.successPortfolio = '';
			$scope.shows = false;
			$scope.validatePortfolio = '';
			$scope.validateSearch = '';
			$scope.alreadySearch = '';
			$scope.getConstituentData(page);
			if (flag == "cons") {
				$scope.showscons = true;
				$scope.showsPortfolio = false;
			}
		}

		// Yash
		$scope.openConstitutent = function(flag) {
			$scope.successPortfolio = '';
			$scope.shows = false;
			$scope.validatePortfolio = '';
			$scope.validateSearch = '';
			$scope.alreadySearch = '';
			$scope.getConstituentData(1);

			if (flag == "cons") {
				$scope.showscons = true;
				$scope.showsPortfolio = false;
			}
			if (flag == "run") {
				$scope.showscons = false;
				$scope.showsPortfolio = true;
				$scope.cancel();
			}

			$scope.modalInstance = $uibModal.open({
				templateUrl : 'app/industry/industryProfile/Constituents.html',
				scope : $scope,
				controller : 'constituentsDirectiveController',
				controllerAs : 'vm',
			}).closed.then(function() {
				if ($scope.removeIndAlertStatus) {
					$scope.alertAction = 'Set Alert';
					$scope.industryLevelAlertFlag = true;
				}

			});

		}

		$scope.loadHistory = function(nm) {

			if (nm != undefined) {
				$scope.multiindname = nm;
			}

			$uibModal.open({
				templateUrl : 'app/industry/industryProfile/History.html',
				scope : $scope,
				controller : 'historyChartController',
				controllerAs : 'vm',
			}).closed.then(function() {
				if ($scope.removeIndAlertStatus) {
					$scope.alertAction = 'Set Alert';
					$scope.industryLevelAlertFlag = true;
				}

			});
		}

		$scope.getCompanyDetails = function(row, column) {
			
			
			if(row.companyName == "Rating information not available"){
				var html = ' <center> There are no recent rating changes </center>';
			}else{
				
				var html = ' <a class="search" onClick= "getCompany(this)"> '
					+ row.companyName + ' </a> ';
			
				
			}
			
			return html;
			
		};

		$window.getCompany = function(item) {

		
				$scope.searchCompany(
						item.parentNode.component.data.companyCode,
						item.parentNode.component.data.companyName,
						item.parentNode.component.data.companyFlag);


		}
		$scope.searchCompany = function(companyCodeToview, companyName,
				companyFlag) {
			if (companyCodeToview != "") {
				
				if (companyFlag == 'SME' || companyFlag == 'NSIC') {
					var paramsValue = {
							'companyCode' : companyCodeToview,
							'flag' : companyFlag
						};
					var url = $state.href('smeDetails');
					$window.localStorage['companyCodeToRedirect']=JSON
					.stringify(paramsValue);;
					$window.open(url,'_blank');
					
				} else {
					var paramsValue = {
							'companyCode' : companyCodeToview,
							'flag' :companyFlag,
							'companyName' : companyName
						};
					console.log(paramsValue);
				var url = $state.href('companyDetails');
				$window.localStorage['companyCodeToRedirect']=JSON
				.stringify(paramsValue);
				$window.open(url,'_blank');
					
					
				}
				$anchorScroll();
			}
		}

		$scope.$on("$destroy", function() {
			$window.localStorage.removeItem('industryId');
			$window.localStorage.removeItem('industryName');
			$window.localStorage.removeItem('label');
			$window.localStorage.removeItem('industryAlertFlag');
			$window.localStorage.removeItem('compObj');
		});
	
	}

	// Yash
	angular.module('quantixApp').controller('constituentsDirectiveController',
			constituentsDirectiveController);

	constituentsDirectiveController.$inject = [ '$uibModalInstance', '$scope' ];

	function constituentsDirectiveController($uibModalInstance, $scope) {
		$scope.cancel = function() {
			// $scope.showscons=false;
			$uibModalInstance.dismiss('cancel');

		}

	}
	// Yash

	angular.module('quantixApp').controller(
			'industryProfileDirectiveController',
			industryProfileDirectiveController);

	industryProfileDirectiveController.$inject = [ '$scope' ];

	function industryProfileDirectiveController($scope) {
		$scope.selectedparamName = {};

		$scope.arrofparam = Object
				.keys($scope.$parent.listformovements.upwards);

		$scope.year = $scope.$parent.year;

		$scope.selectedparamName.paraname = $scope.arrofparam[0];
		$scope.upwardMovementParam = $scope.$parent.listformovements.upwards;
		$scope.downwardMovementParam = $scope.$parent.listformovements.downwards;
		$scope.mixedMovementParam = $scope.$parent.listformovements.mixed;
        $scope.detailNA="Details is Not Available";
		$scope.getData = function(param) {

			$scope.showtopbottomperformers = true;
			$scope.setUnit(param);

			if ($scope.name == 'mixed') {

				$scope.dataToDisplay = $scope.mixedMovementParam[param];
			}
			if ($scope.name == 'upward') {
				$scope.dataToDisplay = $scope.upwardMovementParam[param];
			}
			if ($scope.name == 'downward') {

				$scope.dataToDisplay = $scope.downwardMovementParam[param];
			}
			$scope.dispOutput = [];

			Object.keys($scope.dataToDisplay).forEach(function(key) {

				var temp = {
					"companyName" : key,
					"value" : $scope.dataToDisplay[key]
				}

				$scope.dispOutput.push(temp);

			});

			$scope.showtopbottomperformers = true;

			/*
			 * if ($scope.dispOutput.length >= 5) {
			 * $scope.showtopbottomperformers = true; } else {
			 * $scope.showtopbottomperformers = false; }
			 */

		}

		$scope.setUnit = function(param) {

			if ('Adjusted Debt / Adjusted Networth'.toUpperCase() == param
					.toUpperCase()
					|| 'PBDIT / FinCharges'.toUpperCase() == param
							.toUpperCase()) {
				if ($scope.name == 'mixed') {
					$scope.mixedDataUnit = 'bps';
				}
				if ($scope.name == 'upward') {
					$scope.upwardDataUnit = 'Times';
				}
				if ($scope.name == 'downward') {
					$scope.downwardDataUnit = 'Times';
				}
			} else if ('Net Profit Margin'.toUpperCase() == param.toUpperCase()
					|| 'Operating Margin'.toUpperCase() == param.toUpperCase()
					|| 'ROCE'.toUpperCase() == param.toUpperCase()
					|| 'RPAT / Avg Total Assets'.toUpperCase() == param
							.toUpperCase()
					|| 'Capital Adequacy ratio'.toUpperCase() == param
							.toUpperCase()
					|| 'Net Interest Income / Avg Total Assets'.toUpperCase() == param
							.toUpperCase()
					|| 'Gross NPA / Gross Advances'.toUpperCase() == param
							.toUpperCase()
					|| 'Capital Adequacy Ratio'.toUpperCase() == param
							.toUpperCase()) {
				if ($scope.name == 'mixed') {
					$scope.mixedDataUnit = 'bps';
				}
				if ($scope.name == 'upward') {
					$scope.upwardDataUnit = '%';
				}
				if ($scope.name == 'downward') {
					$scope.downwardDataUnit = '%';
				}
			} else if ('Operating Income'.toUpperCase() == param.toUpperCase()
					|| 'Net Interest Income'.toUpperCase() == param
							.toUpperCase()
					|| 'Total Advances'.toUpperCase() == param.toUpperCase()
					|| 'Assets Under Management'.toUpperCase() == param
							.toUpperCase()
					|| 'Gross NPA'.toUpperCase() == param.toUpperCase()
					|| 'Total Income (Net of interest expenses)'.toUpperCase() == param
							.toUpperCase()) {
				if ($scope.name == 'mixed') {
					$scope.mixedDataUnit = '%';
				}
				if ($scope.name == 'upward') {
					$scope.upwardDataUnit = 'Rs. Crore';
				}
				if ($scope.name == 'downward') {
					$scope.downwardDataUnit = 'Rs. Crore';
				}
			}
		}
		$scope.getData($scope.arrofparam[0]);

	}

	angular.module('quantixApp').controller(
			'industryProfileElementDirectiveController',
			industryProfileElementDirectiveController);

	industryProfileElementDirectiveController.$inject = [ '$scope',
			'$rootScope', /* kaushal */
			'industryService' ];

	function industryProfileElementDirectiveController($scope,
			$rootScope, /* kaushal */
			industryService) {
		
		
		
		
		$scope.showmultipleindustriesdropdown = false;
	
		$scope.selectedinds = $scope.$parent.namesofmultipleirs;
     
		$scope.selectedind = {};

		$scope.selectedind.indname = $scope.$parent.defaultvalforind;
		
		if ($scope.selectedinds.length > 1) {

			$scope.showmultipleindustriesdropdown = true;

		}

		$scope.multipleinddet = $scope.$parent.arrofindwithdetails;
		
		$scope.showmoreflg = false;
		
		$scope.getobjforparind = function(objmulti) {
			
			$scope.arrayOfmulti = [];

			Object.keys(objmulti[0][0]).forEach(function(val) {

				var getProtoForScoreObj = function() {
					return {
						indScore : '',
						riskEntName : '',
						indComments : ''
					}
				}

				var obj = getProtoForScoreObj();

				Object.keys(objmulti[0][0][val]).forEach(

				function(k) {

					obj[k] = objmulti[0][0][val][k];

				});

				$scope.arrayOfmulti.push(obj);

			});

			
			
			Object
					.keys($scope.arrayOfmulti)
					.forEach(
							function(k) {

								if (($scope.arrayOfmulti[k]['riskEntName'] == "Demand Supply Gap")
										|| ($scope.arrayOfmulti[k]['riskEntName'] == "Government Policy")
										|| ($scope.arrayOfmulti[k]['riskEntName'] == "Input Related Risk")
										|| ($scope.arrayOfmulti[k]['riskEntName'] == "Extent of Competition"
												|| $scope.arrayOfmulti[k]['riskEntName'] == "Industry Risk"
												|| $scope.arrayOfmulti[k]['riskEntName'] == "Industry Financials" || $scope.arrayOfmulti[k]['riskEntName'] == "Industry Characteristics")) {

									if ($scope.arrayOfmulti[k]['riskEntName'] == "Demand Supply Gap") {
										a = $scope.arrayOfmulti[k]['riskEntName'];
										e = $scope.arrayOfmulti[k]['indScore'];

									}
									if ($scope.arrayOfmulti[k]['riskEntName'] == "Government Policy") {
										b = $scope.arrayOfmulti[k]['riskEntName'];
										f = $scope.arrayOfmulti[k]['indScore'];

									}
									if ($scope.arrayOfmulti[k]['riskEntName'] == "Input Related Risk") {
										c = $scope.arrayOfmulti[k]['riskEntName'];
										g = $scope.arrayOfmulti[k]['indScore'];

									}
									if ($scope.arrayOfmulti[k]['riskEntName'] == "Extent of Competition") {
										d = $scope.arrayOfmulti[k]['riskEntName'];
										h = $scope.arrayOfmulti[k]['indScore'];

									}

									if ($scope.arrayOfmulti[k]['riskEntName'] == "Industry Risk") {
										if ($scope.arrayOfmulti[k]['indComments'].length > 100) {

											var all = $scope.arrayOfmulti[k]['indComments'];
											$scope.moreflag = true;
											$scope.firstcomments = all.substr(
													0, 200);
											$scope.comments = all
													.substr(0, 200);
											$scope.remainingpart = all.substr(
													1001, all.length);
											$scope.lessflag = false;
											$scope.showmoreflg = true;
										} else {
											$scope.showmoreflg = false;
											$scope.comments = $scope.arrayOfmulti[k]['indComments'];
											$scope.firstcomments = $scope.comments;
										}

										$scope.score = $scope.arrayOfmulti[k]['indScore'];
									}

									if ($scope.arrayOfmulti[k]['riskEntName'] == "Industry Characteristics") {
										$scope.charscore = $scope.arrayOfmulti[k]['indScore'];
									}

									if ($scope.arrayOfmulti[k]['riskEntName'] == "Industry Financials") {
										$scope.finscore = $scope.arrayOfmulti[k]['indScore'];
									}

								}

							});

			$scope.comments = $scope.firstcomments;

			$scope.axes = [ {
				"axisAlpha" : 0,
				"tickAlpha" : 0,
				"labelsEnabled" : false,
				"startValue" : 0,
				"endValue" : 10,
				"startAngle" : 0,
				"endAngle" : 270,
				"bands" : [ {
					"color" : "#eee",
					"startValue" : 0,
					"endValue" : 10,
					"radius" : "100%",
					"innerRadius" : "85%"
				}, {
					"color" : "#84b761",
					"startValue" : 0,
					"endValue" : e,
					"radius" : "100%",
					"innerRadius" : "85%",
					"balloonText" : e
				}, {
					"color" : "#eee",
					"startValue" : 0,
					"endValue" : 10,
					"radius" : "80%",
					"innerRadius" : "65%"
				}, {
					"color" : "#fdd400",
					"startValue" : 0,
					"endValue" : f,
					"radius" : "80%",
					"innerRadius" : "65%",
					"balloonText" : f
				}, {
					"color" : "#eee",
					"startValue" : 0,
					"endValue" : 10,
					"radius" : "60%",
					"innerRadius" : "45%"
				}, {
					"color" : "#cc4748",
					"startValue" : 0,
					"endValue" : g,
					"radius" : "60%",
					"innerRadius" : "45%",
					"balloonText" : g
				}, {
					"color" : "#eee",
					"startValue" : 0,
					"endValue" : 10,
					"radius" : "40%",
					"innerRadius" : "25%"
				}, {
					"color" : "#67b7dc",
					"startValue" : 0,
					"endValue" : h,
					"radius" : "40%",
					"innerRadius" : "25%",
					"balloonText" : h
				} ]
			} ]

			$scope.alllabels = [ {
				"text" : a,
				"x" : "49%",
				"y" : "5%",
				"size" : 12,
				"bold" : true,
				"color" : "#84b761",
				"align" : "right"
			}, {
				"text" : b,
				"x" : "49%",
				"y" : "15%",
				"size" : 12,
				"bold" : true,
				"color" : "#fdd400",
				"align" : "right"
			}, {
				"text" : c,
				"x" : "49%",
				"y" : "24%",
				"size" : 12,
				"bold" : true,
				"color" : "#cc4748",
				"align" : "right"
			}, {
				"text" : d,
				"x" : "49%",
				"y" : "33%",
				"size" : 12,
				"bold" : true,
				"color" : "#67b7dc",
				"align" : "right"
			} ]

			$scope.flag = true;

			var chart = false;

			var initChart = function() {
				if (chart)
					chart.destroy();
				// var config = scope.config || {};
				var config = {};
				chart = AmCharts.makeChart("chartDiv", {
					"type" : "gauge",
					"theme" : "light",
					"axes" : $scope.axes,
					"allLabels" : $scope.alllabels,
					"export" : {
						"enabled" : false
					}
				});

				$scope.loadmymaindirective = true;
			};

			initChart();

			$rootScope.$broadcast('othindustrydata', $scope.arrayOfmulti);

		}

		$scope.plotscoresfor = function(tempvar) {
			
			for ( var a in $scope.multipleinddet) {

				
				if (Object.keys($scope.multipleinddet[a]) == tempvar) {

					$scope.getobjforparind(Object
							.values($scope.multipleinddet[a]));
				}
			}

		// $scope.getobjforparind();

		}

		var a, b, c, d;
		var e, f, g, h;

		$scope.moreflag = false;

		$scope.showmoreflg = false;

		var cnt = 0;
		
		
		Object
				.keys($scope.$parent.arrayOfIndustryParams)
				.forEach(
						function(k) {

							if (($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Demand Supply Gap")
									|| ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Government Policy")
									|| ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Input Related Risk")
									|| ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Extent of Competition"
											|| $scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Industry Risk"
											|| $scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Industry Financials" || $scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Industry Characteristics")) {

								if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Demand Supply Gap") {
									a = $scope.$parent.arrayOfIndustryParams[k]['riskEntName'];
									e = $scope.$parent.arrayOfIndustryParams[k]['indScore'];

								}
								if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Government Policy") {
									b = $scope.$parent.arrayOfIndustryParams[k]['riskEntName'];
									f = $scope.$parent.arrayOfIndustryParams[k]['indScore'];

								}
								if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Input Related Risk") {
									c = $scope.$parent.arrayOfIndustryParams[k]['riskEntName'];
									g = $scope.$parent.arrayOfIndustryParams[k]['indScore'];

								}
								if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Extent of Competition") {
									d = $scope.$parent.arrayOfIndustryParams[k]['riskEntName'];
									h = $scope.$parent.arrayOfIndustryParams[k]['indScore'];

								}

								if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Industry Risk") {
									if (null != $scope.$parent.arrayOfIndustryParams[k]['indComments']
											&& $scope.$parent.arrayOfIndustryParams[k]['indComments'].length > 100) {

										var all = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
 										$scope.moreflag = true;
										$scope.firstcomments = all.substr(0,
												200);
										$scope.comments = all.substr(0, 200);
 										$scope.remainingpart = all.substr(200,
												all.length);
 										$scope.lessflag = false;
										$scope.showmoreflg = true;
									} else {
										$scope.showmoreflg = false;
										$scope.comments = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
										$scope.firstcomments = $scope.comments;
										
 									}

									$scope.score = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
								}

								if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Industry Characteristics") {
									$scope.charscore = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
								}

								if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Industry Financials") {
									$scope.finscore = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
								}

							}

						});
	
		$scope.showMore = function() {
			$scope.commentsfull = $scope.firstcomments +$scope.remainingpart;
			$scope.moreflag = false;
			$scope.lessflag = true;
 			$('#commentSection').modal('show');

		}

		$scope.comments = $scope.firstcomments;
		
		$scope.axes = [ {
			"axisAlpha" : 0,
			"tickAlpha" : 0,
			"labelsEnabled" : false,
			"startValue" : 0,
			"endValue" : 10,
			"startAngle" : 0,
			"endAngle" : 270,
			"bands" : [ {
				"color" : "#eee",
				"startValue" : 0,
				"endValue" : 10,
				"radius" : "100%",
				"innerRadius" : "85%"
			}, {
				"color" : "#647685",
				"startValue" : 0,
				"endValue" : e,
				"radius" : "100%",
				"innerRadius" : "85%",
				"balloonText" : e
			}, {
				"color" : "#eee",
				"startValue" : 0,
				"endValue" : 10,
				"radius" : "80%",
				"innerRadius" : "65%"
			}, {
				"color" : "#84b761",
				"startValue" : 0,
				"endValue" : f,
				"radius" : "80%",
				"innerRadius" : "65%",
				"balloonText" : f
			}, {
				"color" : "#eee",
				"startValue" : 0,
				"endValue" : 10,
				"radius" : "60%",
				"innerRadius" : "45%"
			}, {
				"color" : "#a6a6a6",
				"startValue" : 0,
				"endValue" : g,
				"radius" : "60%",
				"innerRadius" : "45%",
				"balloonText" : g
			}, {
				"color" : "#eee",
				"startValue" : 0,
				"endValue" : 10,
				"radius" : "40%",
				"innerRadius" : "25%"
			}, {
				"color" : "#eecfba",
				"startValue" : 0,
				"endValue" : h,
				"radius" : "40%",
				"innerRadius" : "25%",
				"balloonText" : h
			} ]
		} ]

		$scope.alllabels = [ {
			"text" : a,
			"x" : "49%",
			"y" : "5%",
			"size" : 13,
			"bold" : false,
			"color" : "#647685",
			"align" : "right"
		}, {
			"text" : b,
			"x" : "49%",
			"y" : "15%",
			"size" : 13,
			"bold" : false,
			"color" : "#83b8aa",
			"align" : "right"
		}, {
			"text" : c,
			"x" : "49%",
			"y" : "24%",
			"size" : 13,
			"bold" : false,
			"color" : "#a6a6a6",
			"align" : "right"
		}, {
			"text" : d,
			"x" : "49%",
			"y" : "33%",
			"size" : 13,
			"bold" : false,
			"color" : "#eecfba",
			"align" : "right"
		} ]

	
		$scope.flag = true;

		var chart = false;

		var initChart = function() {
			if (chart)
				chart.destroy();
			// var config = scope.config || {};
			var config = {};
			chart = AmCharts.makeChart("chartDiv", {
				"type" : "gauge",
				"theme" : "light",
				"axes" : $scope.axes,
				"allLabels" : $scope.alllabels,
				"export" : {
					"enabled" : false
				}
			});

			$scope.loadmymaindirective = true;
		};

if( $scope.$parent.arrayOfIndustryParams.length > 0){
			
	initChart();
		}
		$scope.showHistory = function(nm) {

			$scope.$parent.loadHistory(nm);
		}

	}

	angular.module('quantixApp').controller(
			'industryProfileScoreDirectiveController',
			industryProfileScoreDirectiveController);

	industryProfileScoreDirectiveController.$inject = [ '$scope', '$timeout',
			'$rootScope' ];

	function industryProfileScoreDirectiveController($scope, $timeout,
			$rootScope) {

		$rootScope.$on('othindustrydata', function(event, data) {

			$timeout(function() {
				$scope.$parent.arrayOfIndustryParams = data;
				$scope.loadscoresforchars();
			}, 100)

		});

		var colorcode = "";
		function getColorCode(val) {
			if (val <= 3.5) {
				colorcode = "#fc9d9b";
			} else if (val > 3.5 && val <= 6) {
				colorcode = "#faa61a";
			} else if (val > 6) {
				colorcode = "#82ac1a";
			}
			return colorcode;
		}

		$scope.loadscoresforchars = function() {

			$timeout(
					function() {

						Object
								.keys($scope.$parent.arrayOfIndustryParams)
								.forEach(
										function(k) {

											$scope.showele = false;
											if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Industry Risk") {

												if ($scope.char == 'score') {

													$scope.nocomments = false;

													$scope.heading = "IRS Score";
													$scope.score = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
													$scope.comments = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
													$scope.color = getColorCode($scope.score);

													if ($scope.comments == '') {

														$scope.nocomments = true;

													}

												}

											}

											if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Industry Characteristics") {

												if ($scope.char == 'Industry Characteristics') {

													$scope.nocomments = false;

													$scope.heading = "Industry Characteristics";
													$scope.score = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
													$scope.comments = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
													$scope.color = getColorCode($scope.score);

													if ($scope.comments == '') {

														$scope.nocomments = true;

													}

												}

											}

											if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Industry Financials") {

												if ($scope.char == 'Industry Financials') {

													$scope.nocomments = false;

													$scope.heading = "Industry Financials";
													$scope.score = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
													$scope.comments = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
													$scope.color = getColorCode($scope.score);

													if ($scope.comments == '') {

														$scope.nocomments = true;

													}

												}

											}

											if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Demand Supply Gap") {

												if ($scope.char == 'Demand Supply Gap') {

													$scope.nocomments = false;

													$scope.heading = "Demand Supply Gap";
													$scope.score = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
													$scope.comments = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
													$scope.color = getColorCode($scope.score);

													if ($scope.comments == '') {

														$scope.nocomments = true;

													}

												}

											}

											if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Government Policy") {

												if ($scope.char == 'Government Policy') {

													$scope.nocomments = false;

													$scope.heading = "Government Policy";
													$scope.score = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
													$scope.comments = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
													$scope.color = getColorCode($scope.score);

													if ($scope.comments == '') {

														$scope.nocomments = true;

													}

												}

											}
											if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Input Related Risk") {

												if ($scope.char == 'Input Related Risk') {

													$scope.nocomments = false;

													$scope.heading = "Input Related Risk";
													$scope.score = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
													$scope.comments = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
													$scope.color = getColorCode($scope.score);

													if ($scope.comments == '') {

														$scope.nocomments = true;

													}

												}

											}

											if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Extent of Competition") {

												if ($scope.char == 'Extent of Competition') {

													$scope.nocomments = false;

													$scope.heading = "Extent of Competition";
													$scope.score = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
													$scope.comments = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
													$scope.color = getColorCode($scope.score);

													if ($scope.comments == '') {

														$scope.nocomments = true;

													}

												}

											}

											if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "Operating Margin of Industry") {

												if ($scope.char == 'Operating Margin of Industry') {

													$scope.nocomments = false;

													$scope.heading = "Operating Margin of Industry";
													$scope.score = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
													$scope.color = getColorCode($scope.score);
													$scope.comments = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
													if ($scope.comments == null) {

														$scope.nocomments = true;

													}

												}

											}

											if ($scope.$parent.arrayOfIndustryParams[k]['riskEntName'] == "ROCE of Industry") {

												if ($scope.char == 'ROCE of Industry') {

													$scope.nocomments = false;

													$scope.heading = "ROCE of Industry";
													$scope.score = $scope.$parent.arrayOfIndustryParams[k]['indScore'];
													$scope.comments = $scope.$parent.arrayOfIndustryParams[k]['indComments'];
													$scope.color = getColorCode($scope.score);

													if ($scope.comments == null) {

														$scope.nocomments = true;

													}

												}

											}

										})

					}, 100)

		}

	}

	angular
			.module('quantixApp')
			.directive(
					'dispResult',
					function() {
						return {
							restrict : 'E',
							replace : 'true',
							scope : {
								name : '@'

							},
							templateUrl : 'app/industry/industryProfile/industryProfileDirectiveTemplate.html',

							controller : industryProfileDirectiveController
						};
					});

	angular
			.module('quantixApp')
			.directive(
					'dispScore',
					function() {
						return {
							restrict : 'E',
							replace : 'true',
							scope : {
								char : '@'
							},
							templateUrl : 'app/industry/industryProfile/industryProfileScoreDirectiveTemplate.html',

							controller : industryProfileScoreDirectiveController
						};
					});

	angular
			.module('quantixApp')
			.directive(
					'myElem',
					function() {

						return {
							restrict : 'E',
							replace : true,
							scope : {
							/*
							 * axes: '=', alllabels: '='
							 */

							// char : '@'
							},

							templateUrl : 'app/industry/industryProfile/industryProfileScoreMainDirectiveTemplate.html',
							controller : industryProfileElementDirectiveController

						}
					});

	angular.module('quantixApp').controller('historyChartController',
			historyChartController);

	historyChartController.$inject = [ '$uibModalInstance', '$scope',
			'$rootScope', 'industryService' ];

	function historyChartController($uibModalInstance, $scope, $rootScope,
			industryService) {
		$scope.loadChart = false;
		$scope.close = function() {
			// $scope.showscons=false;
			$uibModalInstance.dismiss('cancel');

		}

		$rootScope.$on('nameofmultiind', function(val) {
		});

		// kaushal

		$scope.ratingHistory = [];
		$scope.ratingObj = {};
		$scope.ratingData = {};
		var temp = null;
		var flg = null;
		if ($scope.$parent.multiindname != undefined) {
			temp = $scope.$parent.multiindname;
			flg = 'Y';
		} else {
			temp = $scope.$parent.industryId;
			flg = 'N';
		}
		var obj = {
			industryId : temp,
			flag : flg
		}
		industryService.getRatingHistory(obj).then(

		function(data) {

			$scope.ratingData = data.data;
			$scope.getChart();
		}, function(error) {

		});

		$scope.getChart = function() {

			Object.keys($scope.ratingData).forEach(function(key) {
				var ele = {};

				// $scope.ratingObj.dt = key;
				// $scope.ratingObj.score = $scope.ratingData[key];

				ele.dt = key;
				ele.score = $scope.ratingData[key];
				$scope.ratingHistory.push(ele);
			});
			// $scope.ratingHistory.sort(function(a,
			// b) {
			//
			// if (a.dt > b.dt) {
			// return 1;
			// } else {
			// return -1;
			// }
			//
			// });
			if($scope.ratingHistory.length == 0){
				$scope.historyFound = false;
			}
			else{
				$scope.historyFound = true;
			}
			
			$scope.objforratinghistory = {
				theme : 'black',
				type : 'serial',
				data : $scope.ratingHistory,
				valueAxes : [ {
					unit : "",
					position : "left",
					title : "Industry Risk Score History",
				} ],
				startDuration : 1,
				graphs : [ {
					"id" : "g2",
					"balloon" : {
						"drop" : true,
						"adjustBorderColor" : false,
						"color" : "#ffffff"
					},
					"bullet" : "circle",
					"bulletBorderAlpha" : 1,
					"bulletColor" : "#FFFFFF",
					"bulletSize" : 5,
					"hideBulletsCount" : 50,
					"lineThickness" : 2,
					"title" : "red line",
					"useLineColorForBulletBorder" : true,
					"valueField" : "score",
					"labelText" : "[[score]]",
					"balloonText" : "<span class='font-size-18'>[[score]]</span>"
				} ], //
				plotAreaFillAlphas : 0.1,
				categoryField : "dt",
				categoryAxis : {
					gridPosition : "start",
					parseDates : false,
					labelRotation : 45,
				},

				export : {
					enabled : false
				}
			}

			$scope.loadChart = true;
		}

		// kaushal
	}

	

})();
